const discountSuccessResponse = (discount, totalPrice) => {
  let message = "";

  if (discount.type === "ریال") {
    if (discount.amount > totalPrice) {
      discount.amount = totalPrice;
    }

    message =
      "مبلغ " +
      discount.amount.toLocaleString() +
      " ریال به کیف پول شما پس از پرداخت باز می‌گردد";
  } else {
    message =
      discount.amount +
      " درصد معادل " +
      Math.round(totalPrice * (discount.amount / 100)).toLocaleString() +
      " ریال به کیف پول شما پس از پرداخت باز می‌گردد";
  }

  return "کد تخفیف با موفقیت اعمال شد\n" + message;
};

export default discountSuccessResponse;
